import {
  GreyDescription,
  ItalicRedHeading,
  PreviewHeading,
  PrevieWhiteHeading,
} from "../Global/GlobalText";
import "./EventLivePreview.scss";
import React, { useEffect, useState } from "react";
import star from "../../Assets/start.png";
import adminimg from "../../Assets/adminimg.jpg";
import { CreateButton } from "../Global/GlobalButton";
import { MdOutlineKeyboardArrowDown } from "react-icons/md";
import axios from "axios";
import { EXHANGE_URL_EVENT_PAGE, IMAGES_URL } from "../../Url/Url";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import DOMPurify from "dompurify";
import Page404 from "../404/Page404";
import styled from "styled-components";
import { useSelector } from "react-redux";

export const EventLivePreview2 = () => {
  const { prefix } = useParams();

  const [eventData, setEventData] = useState([]);
  const [error, setError] = useState(false);
  const [apiError, setApiError] = useState(false);
  const [loading, setLoading] = useState(true);
  const token = localStorage.getItem("token");
  const userRole = useSelector((state) => state?.users?.user?.role);
  console.log(userRole, "role");
  const navigate = useNavigate();
  useEffect(() => {
    async function setCurrentUrl(){
      console.log(window.location)
      localStorage.setItem("eventprefix",window.location.pathname)
    }
    setCurrentUrl()
  },[])
  const getEventData = async () => {
    setLoading(true); // Set loading before API call
    try {
      const response = await axios.get(
        `${EXHANGE_URL_EVENT_PAGE}/general?event_url=${prefix}`,
        {
          headers: {
            "Content-Type": "Application/json",
          },
        }
      );

      if (response.status === 200) {
        toast.success("Welcome");
        setEventData(response.data.data);
        setApiError(false);
      }
    } catch (error) {
      console.log(error);
      setError(true);

      if (error.response && error.response.status === 400) {
        setApiError(true);
      }
    } finally {
      setLoading(false); // Ensure loading is set to false when request completes
    }
  };

  console.log(eventData, "fffffffff");
  useEffect(() => {
    getEventData();
  }, [token]);

  const formatDate = (date) => {
    const suffix = ["st", "nd", "rd", "th"];
    const d = new Date(date);
    const day = d.getDate();
    const dayWithSuffix = day + (suffix[(day % 10) - 1] || suffix[3]);
    const month = d.toLocaleString("default", { month: "long" });
    const year = d.getFullYear();

    return `${dayWithSuffix} ${month}, ${year}`;
  };

  const isEventClosed = new Date() > new Date(eventData.closing_date);

  const handleSubmit = () => {
    if (!eventData) return;

    const token =
      localStorage.getItem("token") || sessionStorage.getItem("token");

    if (token) {
      if (userRole === "admin") {
        navigate("/user-submission-details", {
          state: {
            eventId: eventData.eventId,
            registrationFormId: eventData.registrationFormId,
            entryFormId: eventData.entryFormId,
            event_logo: eventData.event_logo,
            event_banner: eventData.event_banner,
            closing_date: eventData.closing_date,
            closing_time: eventData.closing_time,
            event_name: eventData.event_name,
          },
        });
      } else {
        navigate("/user-registration-details", {
          state: {
            eventId: eventData.eventId,
            registrationFormId: eventData.registrationFormId,
            entryFormId: eventData.entryFormId,
            event_logo: eventData.event_logo,
            event_banner: eventData.event_banner,
            closing_date: eventData.closing_date,
            closing_time: eventData.closing_time,
            event_name: eventData.event_name,
          },
        });
      }
    } else {
      navigate("/", {
        state: {
          eventId: eventData.eventId,
          registrationFormId: eventData.registrationFormId,
          entryFormId: eventData.entryFormId,
          event_logo: eventData.event_logo,
          event_banner: eventData.event_banner,
          closing_date: eventData.closing_date,
          closing_time: eventData.closing_time,
          event_name: eventData.event_name,
        },
      });
    }
  };

  if (loading) {
    return <p className="loading-message">Loading event details...</p>;
  }

  if (apiError) {
    return (
      <>
        <p className="error-message" style={{ textAlign: "center" }}>
          Unable to Find any event with this URL. Please check the event link or
          try again later.
        </p>
        <div className="btn" style={{ width: "100%" }}>
          <CreateButton
            onClick={() => {
              if (userRole === "user") {
                navigate("/user-dashboard");
              } else if (userRole === "admin") {
                navigate("/dashboard");
              } else {
                navigate("/");
              }
            }}
          >
            Go to Home Page
          </CreateButton>
        </div>
      </>
    );
  }

  console.log(eventData, "eventData");

  if (eventData && !eventData.is_live) {
    return (
      <>
        <div className="error-message" style={{ textAlign: "center" }}>
          {eventData.closing_messsage && (
            <div
              dangerouslySetInnerHTML={{ __html: eventData.closing_messsage }}
            />
          )}
        </div>
        <div className="btn" style={{ width: "100%" }}>
          <CreateButton
            onClick={() => {
              if (userRole === "user") {
                navigate("/");
              } else if (userRole === "admin") {
                navigate("/dashboard");
              } else {
                navigate("/");
              }
            }}
          >
            Go to Home Page
          </CreateButton>
        </div>
      </>
    );
  }

  if (error) {
    return (
      <p className="error-message">Event is deleted or link has expired.</p>
    );
  }
  const isSubmissionLimitReached =
    eventData.submission_limit > 0 &&
    eventData.submissionsPresent >= eventData.submission_limit;

  const handleEntrySubmission = () => {
    if (isSubmissionLimitReached) {
      toast.error("Event submission limit has been reached.");
      return;
    }

    handleSubmit();
  };

  if (eventData && isEventClosed) {
    return (
      <>
        <EventLive>
          <div className="event_preview_main">
            <div className="event_preview_top">
              <img
                src={`${IMAGES_URL}/${eventData.event_logo}`}
                alt="event_preview"
              />
              <PrevieWhiteHeading>{eventData.event_name}</PrevieWhiteHeading>
              <div className="admin_div">
                {/* <img src={adminimg} alt="admin_login" />
            <span>Kathryn Murphy</span> */}
                {/* <MdOutlineKeyboardArrowDown /> */}
              </div>
            </div>
            <div className="event_preview_bg">
              <img
                src={`${IMAGES_URL}/${eventData.event_banner}`}
                alt="banner"
              />
            </div>
            <div className="event_preview_submit_div">
              <div className="event_preview_star_div">
                <div className="event_preview_sub">
                  <img src={star} alt="star" />
                  <GreyDescription style={{ fontWeight: "600" }}>
                    {isEventClosed
                      ? "Event is closed"
                      : `Event will be closed on ${formatDate(
                          eventData.closing_date
                        )}`}
                  </GreyDescription>
                </div>
              </div>
              <CreateButton
                onClick={() => {
                  if (userRole === "user") {
                    navigate("/");
                  } else if (userRole === "admin") {
                    navigate("/dashboard");
                  } else {
                    navigate("/");
                  }
                }}
              >
                Go to Home Page
              </CreateButton>
            </div>
          </div>
          <div
            className="div_value"
            style={{
              border: "1px solid #ddd",
              padding: "10px",
              margin: "0px",
              minHeight: "100px",
              display: "flex",
              flexDirection: "column",
              justifyContent: "start",
              alignItems: "start",
              marginBottom: "4rem",
            }}
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(eventData.closing_messsage),
            }}
          />

          <div className="footeeer">
            <div className="contact-icon">
              <button
                onClick={() =>
                  window.open(
                    `https://mail.google.com/mail/?view=cm&fs=1&to=${eventData.adminemail}`,
                    "_blank"
                  )
                }
              >
                Contact To Organizer
              </button>

              {/* Optional hover email */}
              <div className="email-hover">mailto:{eventData.adminemail}</div>
            </div>

            {/* Move this OUTSIDE so it spans full width */}
            <div className="email-line">
              Powered by Retail Advising Services Pvt. Ltd. (An IMAGES Group
              Company)
              <br />
            </div>
          </div>
        </EventLive>
      </>
    );
  }

  return (
    <EventLive>
      <div className="event_preview_main">
        <div className="event_preview_top">
          <img
            src={`${IMAGES_URL}/${eventData.event_logo}`}
            alt="event_preview"
          />
          <PrevieWhiteHeading>{eventData.event_name}</PrevieWhiteHeading>
          <div className="admin_div">
            {/* <img src={adminimg} alt="admin_login" />
            <span>Kathryn Murphy</span> */}
            {/* <MdOutlineKeyboardArrowDown /> */}
          </div>
        </div>
        <div className="event_preview_bg">
          <img src={`${IMAGES_URL}/${eventData.event_banner}`} alt="banner" />
        </div>
        <div className="event_preview_submit_div">
          <div className="event_preview_star_div">
            <div className="event_preview_sub">
              <img src={star} alt="star" />
              <GreyDescription style={{ fontWeight: "600" }}>
                {isEventClosed
                  ? "Event is closed"
                  : `Event will be closed on ${formatDate(
                      eventData.closing_date
                    )}`}
              </GreyDescription>
            </div>
          </div>
          <CreateButton onClick={handleEntrySubmission}>
            Submit An Entry
          </CreateButton>
        </div>
      </div>
      <div
        className="div_value"
        style={{
          border: "1px solid #ddd",
          padding: "10px",
          margin: "0px",
          minHeight: "100px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "start",
          alignItems: "start",
          marginBottom: "4rem",
        }}
        dangerouslySetInnerHTML={{
          __html: DOMPurify.sanitize(eventData.event_description),
        }}
      />

      <div className="footeeer">
        <div className="contact-icon">
          <button
            onClick={() =>
              window.open(
                `https://mail.google.com/mail/?view=cm&fs=1&to=${eventData.adminemail}`,
                "_blank"
              )
            }
          >
            Contact To Organizer
          </button>

          {/* Optional hover email */}
          <div className="email-hover">mailto:{eventData.adminemail}</div>
        </div>

        {/* Move this OUTSIDE so it spans full width */}
        <div className="email-line">
          Powered by Retail Advising Services Pvt. Ltd. (An IMAGES Group
          Company)
          <br />
        </div>
      </div>
    </EventLive>
  );
};

const EventLive = styled.section`
  .event_preview_main {
    width: 100%;
    // max-width: 1200px;
    // margin: auto;
  }

  .event_preview_top img {
    max-width: 100px;
    width: 100%;
    height: 100px;
    object-fit: contain;
    // margin: auto;
    display: block;
  }

  @media (max-width: 768px) {
    .event_preview_top img {
      max-width: 70px;
      width: 100%;
      height: 70px;
    }
  }
  @media (min-width: 465px) {
    .event_preview_top img {
      max-width: 50px;
      width: 100%;
      height: 50px;
    }
  }
  .div_value {
    p {
      margin: 0px !important;
      margin-bottom: 0px !important;
      text-align: start;
    }
  }

  .footeeer {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    padding: 15px 20px 15px 20px;
    background: rgb(134, 134, 134);
    display: flex;
    justify-content: flex-start; /* Align to the left */
    z-index: 999;
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.05);
    display: flex;
    justify-content: space-between;
    @media (max-width: 567px) {
      padding: 15px 20px 10px 20px;

      .contact-icon button {
        padding: 6px;
        font-size: 10px;
      }
      .email-line {
        font-size: 10px;
         text-align: center;
      line-height: 1.4;
      }
    }
  }

  .contact-icon {
    display: flex;
    flex-direction: column;
    position: relative;
    cursor: pointer;
    font-size: 20px;
    color: #fff;
    font-weight: bold;
  }

  .email-line {
    margin-top: 8px;
    font-size: 14px;
    color: #fff;
    font-weight: 400;
    text-align: center;
  }

  .email-hover {
    position: absolute;
    left: 100%;
    white-space: nowrap;
    margin-left: 10px;
    color: #fff;
    font-size: 16px;
    font-weight: normal;
    opacity: 0;
    visibility: hidden;
    transition: opacity 0.3s ease, transform 0.3s ease;
    transform: translateX(0);
  }

  .contact-icon:hover .email-hover {
    opacity: 1;
    visibility: visible;
    transform: translateX(5px);
  }

  .contact-icon button {
    background-color: #f0f0f0;
    color: #333;
    border: none;
    padding: 10px 16px;
    font-size: 14px;
    border-radius: 6px;
    font-weight: 600;
    cursor: pointer;
    transition: background-color 0.3s ease, transform 0.2s ease;
    max-width: fit-content;
  }

  .contact-icon button:hover {
    background-color: #e0e0e0;
    transform: translateY(-1px);
  }

  @media (max-width: 768px) {
    .email-hover {
      position: relative;
      left: 0;
      margin-left: 0;
      transform: translateX(0);
      opacity: 1;
      visibility: visible;
      font-size: 12px;
      margin-top: 5px;
    }

    .contact-icon:hover .email-hover {
      transform: none;
    }
  }
`;
